module.exports = __webpack_public_path__ + "static/media/Widget-Analytics.018a8069.png";